import { Link } from 'react-router-dom';

// Logo image URL
const LOGO_URL = '/logo.png';

// Logo icon component using the uploaded image
export function LogoIcon({ className = "w-12 h-12" }) {
  return (
    <img 
      src={LOGO_URL} 
      alt="Desqly Logo" 
      className={`${className} object-contain`}
    />
  );
}

// Full logo with text
export function Logo({ className = "", size = "default", linkTo = "/" }) {
  const sizes = {
    small: { icon: "w-10 h-10", text: "text-xl" },
    default: { icon: "w-12 h-12", text: "text-2xl" },
    large: { icon: "w-16 h-16", text: "text-3xl" }
  };
  
  const { icon, text } = sizes[size] || sizes.default;

  const content = (
    <div className={`flex items-center gap-3 ${className}`}>
      <LogoIcon className={icon} />
      <span className={`${text} font-bold bg-gradient-to-r from-teal-600 to-cyan-500 bg-clip-text text-transparent`}>
        Desqly
      </span>
    </div>
  );

  if (linkTo) {
    return <Link to={linkTo} data-testid="logo">{content}</Link>;
  }
  
  return content;
}

// Logo without text (icon only)
export function LogoMark({ className = "w-10 h-10" }) {
  return (
    <img 
      src={LOGO_URL} 
      alt="Desqly" 
      className={`${className} object-contain`}
    />
  );
}

// Large logo for auth pages and splash screens
export function LogoLarge({ className = "" }) {
  return (
    <div className={`flex flex-col items-center gap-4 ${className}`}>
      <img 
        src={LOGO_URL} 
        alt="Desqly Logo" 
        className="w-24 h-24 object-contain"
      />
      <span className="text-3xl font-bold bg-gradient-to-r from-teal-600 to-cyan-500 bg-clip-text text-transparent">
        Desqly
      </span>
    </div>
  );
}

export default Logo;
